enum ServiceLoggerProperties {
  CHROME_EXTENSION = 'chrome-extension',
  WEB_APP = 'web-app',
  OUTLOOK_ADD_IN = 'outlook-add-in',
  DIALER = 'omnidialer',
}

enum ExtensionFeatureSet {
  OMNIBAR = 'Omnibar',
  EMAIL_COMPONENTS = 'EmailComponents',
  CALENDAR_COMPONENTS = 'CalendarComponents',
  SALESFORCE_REPORT_PAGE_COMPONENTS = 'SalesforceReportPageComponents',
  SALESFORCE_DETAILS_PAGE_COMPONENTS = 'SalesforceDetailsPageComponents',
  SALESFORCE_LIST_VIEW_COMPONENTS = 'SalesforceListViewComponents',
  LIGHTNING_OUT = 'LightningOut',
  EMAIL_TOOLS = 'EmailTools',
  OUTLOOK_ENTRYPOINTS = 'OutlookEntrypoints',
  OUTLOOK_TASKPANE = 'OutlookTaskpane',
}

enum ExtensionComponents {
  // Omnibar Components
  OMNIBAR = 'Omnibar',
  OMNIBAR_ERROR = 'OmnibarError',
  INLINE_CREATE_FORM = 'InlineCreateForm',
  TOP_BAR = 'TopBar',

  // Email Components
  CLARI_GROOVE_MENU_BUTTON = 'ClariGrooveMenuButton',
  EMAIL_COMPOSE_TOOLBAR = 'EmailComposeToolbar',
  EMAIL_REMINDER_BUTTON = 'EmailReminderButton',
  INBOX_MESSAGE_HEADER_LOG_BUTTON = 'InboxMessageHeaderLogButton',
  INBOX_LIST_TRACKING_BUTTON = 'InboxListTrackingButton',

  // Calendar Components
  CALENDAR_HEADER_NOTES_BUTTON = 'CalendarHeaderNotesButton',
  CALENDAR_MEETING_PREVIEW_NOTES_BUTTON = 'CalendarMeetingPreviewNotesButton',
  CALENDER_LOGGING_BAR = 'CalenderLoggingBar',

  // Outlook Email Tools
  EMAIL_TOOLS_ADD_SPECIFIC_TIMES = 'EmailToolsAddSpecificTimes',

  // Salesforce Report Page Components
  REPORT_CLICK_TO_EMAIL_BUTTON = 'ReportClickToEmailButton',
  REPORT_CLICK_TO_CALL_BUTTON = 'ReportClickToCallButton',

  // Salesforce Details Page Components
  DETAILS_CLICK_TO_EMAIL_BUTTON = 'DetailsClickToEmailButton',
  DETAILS_CLICK_TO_CALL_BUTTON = 'DetailsClickToCallButton',
  DETAILS_RELATED_ADD_TO_GROOVE_BUTTON = 'DetailsRelatedAddToGrooveButton',
  DETAILS_ADD_TO_GROOVE_COMBO_BUTTON = 'DetailsAddToGrooveComboButton',
  DETAILS_RELATED_ADD_TO_SPACE_BUTTON = 'DetailsRelatedAddToSpaceButton',
  DETAILS_ADD_TO_SPACE_BUTTON = 'DetailsAddToSpaceButton',

  // Salesforce List View Components
  LIST_VIEW_CLICK_TO_EMAIL_BUTTON = 'ListViewClickToEmailButton',
  LIST_VIEW_CLICK_TO_CALL_BUTTON = 'ListViewClickToCallButton',
  LIST_VIEW_ADD_TO_GROOVE_BUTTON = 'ListViewAddToGrooveButton',
  BULK_ADD_TO_FLOW_BUTTON = 'BulkAddToFlowButton',

  // Lightning out
  CONFIGURE_LIGHTNING_OUT_COMPONENT = 'ConfigureLightningOutExtensionComponent',
  CONFIGURE_LIGHTNING_OUT_INITIALIZE = 'ConfigureLightningOutExtensionInitialize',
  CONFIGURE_LIGHTNING_OUT_MOUNT = 'ConfigureLightningOutExtensionMount',

  // Outlook Entrypoint
  OUTLOOK_ENTRYPOINT_TASKPANE = 'OutlookEntrypointTaskpane',
  OUTLOOK_ENTRYPOINT_TASKPANE_INBOX = 'OutlookEntrypointTaskpaneInbox',
  OUTLOOK_ENTRYPOINT_TASKPANE_SAGA_INITIALIZESUGGESTEDRECORDS = 'OutlookEntrypointTaskpaneSagaIntializeSuggestedRecords',
  OUTLOOK_ENTRYPOINT_TASKPANE_SAGA_ROOT = 'OutlookEntrypointTaskpaneSagaRoot',

  // Outlook Taskpane
  OUTLOOK_TASKPANE_LOGS = 'OutlookTaskpaneLogs',
}

export { ServiceLoggerProperties, ExtensionComponents, ExtensionFeatureSet };
